import {
  ContractsWhereColumn,
  OrdersWhereColumn,
  OtherDocumentsWhereColumn,
} from "@src/__generated__/urql-graphql";
import { BaseMixedFilters } from "../../documents/listing/MixedFilters";

export class MixedFilters extends BaseMixedFilters {
  constructor(brandId?: string) {
    super();

    this.where.contracts.hide([
      ContractsWhereColumn.BrandId,
      ContractsWhereColumn.ClientId,
      ContractsWhereColumn.ProjectId,
      ContractsWhereColumn.ContractorId,
    ]);
    this.where.orders.hide([
      OrdersWhereColumn.BrandId,
      OrdersWhereColumn.ProjectId,
    ]);
    this.where.otherDocuments.hide([]);

    if (brandId) {
      this.where.contracts.addImplicitFilter(
        ContractsWhereColumn.BrandId,
        brandId,
      );
      this.where.orders.addImplicitFilter(OrdersWhereColumn.BrandId, brandId);
      this.where.otherDocuments.addImplicitFilter(
        OtherDocumentsWhereColumn.BrandId,
        brandId,
      );
    }
  }
}
